<template>
 <div class="login_container">
    <div class="login_form">
        <h1 v-if="!client_aicha">Login </h1>
        <h1 v-else>Welcome {{client_aicha.firstname}} </h1>
        <div class="login_inputs">
            <input type="text" v-model="user.username" class="login_control" placeholder="Username">
            <input type="passowrd" v-model="user.password" class="login_control" placeholder="Password">
            <div class="signin" @click="SignIn">Login</div>
            <p class="forgot_pwd"><span>Forgot Passowrd ?</span></p>
        </div>
    </div>
 </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {

  props: [],
  data() {
    return {
        user : {
            username:"",
            password:"",
        }
    };
  },
  computed:{
    ...mapGetters(["client_aicha"]),
    is_login(){
        return this.$route.name=="Login";
    }
  },
  methods:{
    ...mapActions(["getLogin"]),
    SignIn(){
      
       this.getLogin({...this.user})
    }
  },
};
</script>

<style >
    .login_container{
            background: #264740;
            width: 100%;
            height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
flex-direction: column;
    }
    .login_form{
        background: #f0774efa;
        padding: 24px;
        border-radius: 50px;
        width: 80%;
    }   
    .login_form h1{
            color: #fff;
            text-transform: uppercase;
            margin-bottom: 24px;
            
    }
    .login_inputs{
        display: flex;
        flex-direction: column;
        justify-content: center;
            align-items: center;
    }
    .login_control{
            margin: 12px 0px;
            height: 39px;
            font-size: 12px !important;
            text-align: center;
            border-radius: 50px;
    }
    .signin{
        background: #264740;
        color: #fff;
        width: 50%;
        padding: 8px;
        border-radius: 50px;
        margin-top: 24px;
        margin-bottom: 24px;
    }
    .forgot_pwd{
        font-size: 12px !important;
        color: #fff;
        font-weight: 600;
        text-decoration: underline;
        cursor: pointer;
    }
</style>
